import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "button"]

  connect() {
    this.handleSelectionChange = this.handleSelectionChange.bind(this)
    document.addEventListener("tableSelection:change", this.handleSelectionChange)
    this.updateButtonDisabledState()
  }

  disconnect() {
    document.removeEventListener("tableSelection:change", this.handleSelectionChange)
  }

  handleSelectionChange(event) {
    this.syncIdsField(event.detail.selectedIds || [])
    this.updateButtonDisabledState()
  }

  updateButtonDisabledState() {
    const hasSelections = this.formTarget.querySelectorAll('input[name="bulk_action[ids][]"]').length > 0
    this.buttonTarget.classList.toggle("disabled", !hasSelections)
  }

  syncIdsField(ids) {
    this.formTarget
      .querySelectorAll('input[name="bulk_action[ids][]"]')
      .forEach(node => node.remove())

    ids.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "bulk_action[ids][]"
      input.value = id
      this.formTarget.appendChild(input)
    })
  }
}
